module.exports = __webpack_public_path__ + "img/sign-in-art-1.c9e1ef55.png";